module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/napoli.0622f4959628c3c25d8e7929b2b0ed24.jpg";